import * as classnames from 'classnames/bind';
import * as React from 'react';
import {FontIcon} from 'src/components/common/FontIcons';
import {Card} from 'src/components/pages/home2/general/Card';
import {Page2, PageProps} from 'src/components/pages/home2/pageCommon/Page2';
import {PageName} from 'src/components/pages/home2/pageCommon/PageNav';
import Accent, {Color, Kind} from 'src/components/pages/home2/text/Accent';
import FIcon, {Size} from 'src/components/pages/home2/text/FIcon';
import Heading, {Align, Type} from 'src/components/pages/home2/text/Heading';

const styles = require('./PricingPage2.module.less');
const cx = classnames.bind(styles) as any;

export interface PricingPage2State
{
	isGetStartedDialogOpened:boolean;
}

export class PricingPage2 extends React.Component<any, PricingPage2State>
{
	constructor(props:PageProps)
	{
		super(props);

		this.state = {isGetStartedDialogOpened: false};
	}

	render()
	{
		const {isGetStartedDialogOpened} = this.state;

		return (
			<div>

				<Page2
					pageName={PageName.Pricing}
					contentClassName={cx('pageContent')}
					showGetStartedDialog={isGetStartedDialogOpened}
					onGetStartedDialogClosed={() =>
					{
						this.setState({isGetStartedDialogOpened: false});
					}}
				>

					<Heading align={Align.Center} className={cx('pageTitle')} type={Type.Title}
							 title={<span>Create software <Accent kind={Kind.Color} color={Color.Blue}>today</Accent>
                                        </span>} />

					<Heading align={Align.Center} className={cx('pageSubtitle')} type={Type.Subtitle}
							 title={<span>with the <Accent color={Color.Orange}>speed</Accent> and <Accent
								 color={Color.Orange}>simplicity</Accent> of a spreadsheet</span>} />

					{
						this._renderCardSet()
					}

				</Page2>
			</div>
		);
	}

	private _renderCardSet()
	{
		return <div className={cx('cardSet')}>

			{this._renderPlan1()}
			{this._renderPlan2()}
			{this._renderPlan3()}

		</div>;
	}

	private onClickGetStarted()
	{
		this.setState({isGetStartedDialogOpened: true});
	}

	private _renderPlan1()
	{
		return <Card className={cx('card')}>
			<div className={cx('planTitle')}>
				Personal
			</div>
			<div
				className={cx('planCTA')}
				onClick={this.onClickGetStarted.bind(this)}
			>
				Get Started
			</div>
			<div className={cx('planPrice')}>
				<div className={cx('amount')}>$95</div>
				<div className={cx('perPeriod')}>/ month</div>
			</div>
			<div className={cx('planDivider')} />

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					1
				</div>
				<div className={cx('regular', 'description')}>
					software author
					<span className={cx('hideBeforeLG')}><br />&nbsp;</span>
				</div>
			</div>

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					All
				</div>
				<div className={cx('regular', 'description')}>
					platform features
				</div>
			</div>

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					Unlimited
				</div>
				<div className={cx('regular', 'description')}>
					end-users
					<span className={cx('hideBeforeLG')}><br />&nbsp;</span>
				</div>
			</div>

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					MintData
				</div>
				<div className={cx('regular', 'description')}>
					Cloud
					<span className={cx('hideBeforeLG')}><br />&nbsp;</span>
				</div>
			</div>

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					MintData
				</div>
				<div className={cx('regular', 'description')}>
					Login
					<span className={cx('hideBeforeLG')}><br /><br />&nbsp;</span>
				</div>
			</div>

			<div className={cx('planDivider')} />

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					<FIcon className={cx('checkIcon')} size={Size.Medium} name={FontIcon.Remove} />
				</div>
				<div className={cx('regular', 'description')}>
					Custom URL for published applications
				</div>
			</div>

			<div className={cx('planDivider')} />

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					Support
				</div>
				<div className={cx('regular', 'description')}>
					Email & Chat
					<span className={cx('hideBeforeLG')}><br />&nbsp;</span>
				</div>
			</div>

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					Training
				</div>
				<div className={cx('regular', 'description')}>
					Online Webinars & Documentation
				</div>
			</div>
		</Card>;
	}

	private _renderPlan2()
	{
		return <Card className={cx('card')}>
			<div className={cx('planTitle')}>
				Team
			</div>
			<div
				className={cx('planCTA')}
				onClick={this.onClickGetStarted.bind(this)}
			>
				Get Started
			</div>
			<div className={cx('planPrice')}>
				<div className={cx('amount')}>$495</div>
				<div className={cx('perPeriod')}>/ month</div>
			</div>
			<div className={cx('planDivider')} />

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					5
				</div>
				<div className={cx('regular', 'description')}>
					software authors
					<span className={cx('hideBeforeLG')}><br />&nbsp;</span>
				</div>
			</div>

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					All
				</div>
				<div className={cx('regular', 'description')}>
					platform features
				</div>
			</div>

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					Unlimited
				</div>
				<div className={cx('regular', 'description')}>
					end-users
					<span className={cx('hideBeforeLG')}><br />&nbsp;</span>
				</div>
			</div>

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					MintData
				</div>
				<div className={cx('regular', 'description')}>
					Cloud
					<span className={cx('hideBeforeLG')}><br />&nbsp;</span>
				</div>
			</div>

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					MintData
				</div>
				<div className={cx('regular', 'description')}>
					Login
					<span className={cx('hideBeforeLG')}><br /><br />&nbsp;</span>
				</div>
			</div>

			<div className={cx('planDivider')} />

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					<FIcon className={cx('checkIcon')} size={Size.Medium} name={FontIcon.CheckSingle} />
				</div>
				<div className={cx('regular', 'description')}>
					Custom URL for published applications
				</div>
			</div>

			<div className={cx('planDivider')} />

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					Support
				</div>
				<div className={cx('regular', 'description')}>
					Email & Chat
					<span className={cx('hideBeforeLG')}><br />&nbsp;</span>
				</div>
			</div>

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					Training
				</div>
				<div className={cx('regular', 'description')}>
					Online Webinars & Documentation
				</div>
			</div>
		</Card>;
	}

	private _renderPlan3()
	{
		return <Card className={cx('card')}>
			<div className={cx('planTitle')}>
				Enterprise
			</div>
			<div
				className={cx('planCTA')}
				onClick={this.onClickGetStarted.bind(this)}
			>
				Get Started
			</div>
			<div className={cx('planPrice')}>
				<div className={cx('amount')}>Contact Us</div>
				{/*<div className={cx('perPeriod')}>/ month</div>*/}
			</div>
			<div className={cx('planDivider')} />

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					Group
				</div>
				<div className={cx('regular', 'description')}>
					team, department, <br /> business unit
				</div>
			</div>

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					All
				</div>
				<div className={cx('regular', 'description')}>
					platform features
				</div>
			</div>

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					Custom
				</div>
				<div className={cx('regular', 'description')}>
					end-users based on use case(s)
				</div>
			</div>

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					On Premise
				</div>
				<div className={cx('regular', 'description')}>
					private cloud or MintData cloud
				</div>
			</div>

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					Single <br />Sign-on
				</div>
				<div className={cx('regular', 'description')}>
					OAuth, SAML, ADFS, LDAP & custom integration
				</div>
			</div>

			<div className={cx('planDivider')} />

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					<FIcon className={cx('checkIcon')} size={Size.Medium} name={FontIcon.CheckSingle} />
				</div>
				<div className={cx('regular', 'description')}>
					Custom URL for published applications
				</div>
			</div>

			<div className={cx('planDivider')} />

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					Support
				</div>
				<div className={cx('regular', 'description')}>
					Custom SLA, Dedicated support
				</div>
			</div>

			<div className={cx('planFeature')}>
				<div className={cx('bold', 'quantity')}>
					Training
				</div>
				<div className={cx('regular', 'description')}>
					Onsite Training Available
				</div>
			</div>
		</Card>;
	}
}

export default () => <PricingPage2 />;
